module.exports = __webpack_public_path__ + "media/images/svgs/icon-association-white-e51c16c04c854ce46ef2ad6d0d59cf61.svg";